// Implements: F-CNV-015
/**
 * The POST that points the mockup at an earlier version and leaves a trace in the thread.
 * It lives in `shared/api` because the screen that offers it is a version page
 * (`versions`) while the route belongs to the conversation, and a module may not import
 * another.
 *
 * It moves a pointer and charges nothing, but it is NOT safe to resend on its own: the
 * pointer may have moved between two attempts (another tab, a promote, a finished turn), and
 * a silent resend would put it back on a version the person no longer meant. So it is never
 * retried (`retry: false`): a lost response reaches the person, who presses the button
 * again if they still want it. (Only the same version twice in a row is a no-op.)
 */

import { ApiError, UNKNOWN_ERROR_CODE } from "./ApiError";
import { conversationPath } from "./conversationPath";
import { httpRequest } from "./httpClient";
import type { ContinuedView } from "../../types/api";

export async function continueFromVersion(
  mockupId: string,
  versionId: string,
): Promise<ContinuedView> {
  const body = await httpRequest<ContinuedView>(`${conversationPath(mockupId)}/continue`, {
    method: "POST",
    body: { version_id: versionId },
    retry: false,
  });
  if (body === undefined) {
    throw new ApiError(200, UNKNOWN_ERROR_CODE, "POST continue answered with no body", new Headers());
  }
  return body;
}
